module.exports = __webpack_public_path__ + "static/media/ic-users-time.6d53e32f.svg";